/**
 * Shared BoxContainer base for the HBox/VBox slices: `alignment` belongs to Godot's BoxContainer, so
 * its type and parse live here, in pure `.ts` for the linter graph.
 */
import { parseOptionalInt } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
/** Control base plus BoxContainer's `alignment` (main-axis packing). */
export function parseBoxContainer(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    result.alignment = parseOptionalInt(properties.alignment);
    return result;
}
//# sourceMappingURL=boxContainer.js.map